import React from 'react';

type ProductScrollWrapperProps = {
  children: React.ReactElement[];
};
export const ProductScrollWrapper = (props: ProductScrollWrapperProps) => {
  return (
    <div
      className="overflow-auto min-h-fit flex flex-nowrap"
    >
      {props.children}
    </div>
  );
};
